import { Message, UpdateRuleNotificationInput } from '@app/models/message.model'

const BODY_MESSAGE_FIELDS = `
    ${Object.keys(new Message()).join('\n')}
`

export const SEND_PUSH_MESSAGE = `
query sendPushMessage($data: pushMessageEventInput!) {
    sendPushMessage(
        data: $data
     ) {
        success
        errorText
        data {
            id
        }
    }
}
`

/* export const GET_MESSAGES = `
query get_messages($client_id: Float!) {
    get_messages(
        client_id: $client_id
    ) {
        success
        errorText
        data {
            id
           client_id
           ${BODY_MESSAGE_FIELDS}
        }
    }
}
`; */

export const GET_FILTERED_MESSAGES = `
query get_messages($data: getMessagesInput!) {
    get_messages(
        data: $data
    ) {
        success
        errorText
        data {
            id
           client_id
           ${BODY_MESSAGE_FIELDS}
        }
    }
}
`

export const GET_RULE_BASED_NOTIFICATIONS = `
query get_rule_notifications_by_client($client_id: Float!) {
    get_rule_notifications_by_client(
        client_id: $client_id
    ) {
        success
        errorText
        data {
            ${Object.keys(new UpdateRuleNotificationInput()).join('\n')}
        }
    }
}
`

export const GET_RULE_NOTIFICATIONS_DETAILS = `
query {
    get_rule_notifications_details {
        success
        errorText
        data {
          target
          initiator
          trigger
        }
    }
}`

export const UPSERT_RULE_NOTIFICATIONS = `
mutation upsert_rule_notifications($data: [upsertRuleNotificationInput!]!) {
    upsert_rule_notifications(data: $data) {
        success
        errorText
    }
}
`

export const DELETE_RULE_NOTIFICATION = `
mutation delete_rule_notification($rule_id: Float!) {
    delete_rule_notification(rule_id: $rule_id) {
        success
        errorText
    }
}
`
